import { useScaleFactor as e } from "../../hooks/useScaleFactor.js";
import "../../hooks/index.js";
import t from "./Header.module.js";
import { c as n } from "react/compiler-runtime";
import r from "classnames";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
import o from "@jetbrains/logos/qodana/qodana.js";
//#region src/components/Header/Header.tsx
function s(s) {
	let c = n(8), { className: l, userControls: u } = s, d = u === void 0 ? null : u, f = 48 * e(), p;
	c[0] === l ? p = c[1] : (p = r(t.header, l), c[0] = l, c[1] = p);
	let m;
	c[2] === f ? m = c[3] : (m = /* @__PURE__ */ i(o, {
		className: t.logo,
		height: f,
		width: f,
		"aria-label": "Qodana product logo",
		"data-test": "qodana-product-logo"
	}), c[2] = f, c[3] = m);
	let h;
	return c[4] !== p || c[5] !== m || c[6] !== d ? (h = /* @__PURE__ */ a("header", {
		className: p,
		children: [m, d]
	}), c[4] = p, c[5] = m, c[6] = d, c[7] = h) : h = c[7], h;
}
//#endregion
export { s as Header };
